import React from 'react';
import * as FlagIcons from "country-flag-icons/react/3x2";

type FlagProps = {
    countryCode: string;
};

export const CountryFlagIcon = ({ countryCode }: FlagProps) => {
    const Flag = FlagIcons[countryCode.toUpperCase() as keyof typeof FlagIcons];
    return <Flag style={{ borderRadius: "2px", width: "18px", marginRight: "9px" }} />;
};

export default CountryFlagIcon;
